export { BioEntitiesPinsList } from './BioEntitiesPinsList.component';
